{
  "en": {
    "checkIn": {
      "time": "Check-in time",
      "from": "Check-in from {Start} to {End}",
      "after": "Check-in after {Time}",
      "before": "Check-in before {Time}",
      "flexible": "Flexible check-in time"
    },
    "checkOut": {
      "time": "Check-out time",
      "from": "Check-out from {Start} to {End}",
      "after": "Check-out after {Time}",
      "before": "Check-out before {Time}",
      "flexible": "Flexible check-out time"
    },
    "pickup": {
      "time": "Pickup time",
      "from": "Pickup from {Start} to {End}",
      "after": "Pickup after {Time}",
      "before": "Pickup before {Time}",
      "flexible": "Flexible pickup time"
    },
    "drop-off": {
      "time": "Drop-off time",
      "from": "Drop-off from {Start} to {End}",
      "after": "Drop-off after {Time}",
      "before": "Drop-off before {Time}",
      "flexible": "Flexible drop-off time"
    }
  },
  "fr": {
    "checkIn": {
      "time": "Heure d'arrivée",
      "from": "Arrivée du VR de {Start} à {End}",
      "after": "Arrivée du VR après {Time}",
      "before": "Arrivée du VR avant {Time}",
      "flexible": "Heure d'arrivée flexible"
    },
    "checkOut": {
      "time": "Heure de départ",
      "from": "Départ du VR de {Start} à {End}",
      "after": "Départ du VR après {Time}",
      "before": "Départ du VR avant {Time}",
      "flexible": "Heure de départ flexible"
    },
    "pickup": {
      "time": "Heure de collecte",
      "from": "Collecte du VR de {Start} à {End}",
      "after": "Collecte du VR après {Time}",
      "before": "Collecte du VR avant {Time}",
      "flexible": "Heure de collecte flexible"
    },
    "drop-off": {
      "time": "Heure de retour",
      "from": "Retour du VR de {Start} à {End}",
      "after": "Retour du VR après {Time}",
      "before": "Retour du VR avant {Time}",
      "flexible": "Heure de retour flexible"
    }
  }
}
